
import { BasicCommand } from "../../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../../common/services/cqs/CommandType";
import { IPrimaryKey } from "../../../../common/services/cqs/IPrimaryKey";

export class UpdateGrotkontraktCommand extends BasicCommand<UpdateGrotkontraktCommand> {

    guid: string;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateGrotkontraktCommand";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "virkeskopskontrakt";

    get primaryKey(): IPrimaryKey<UpdateGrotkontraktCommand> {
        return {
            kontraktGuid: this.guid
        };
    }

    constructor(kontraktGuid: string) {
        super(UpdateGrotkontraktCommand.$type, UpdateGrotkontraktCommand.$groupKey, CommandType.Insert);
        this.guid = kontraktGuid;
    }
}
